// CompilerProvider.js
import { helperService} from './index'
export class CompilerProvider {
    constructor() {
      this.helperService = helperService;
    }
  
    /**
     * Constructs home data from fleet list
     * @param {Object} homeFleetList - Home fleet list data
     * @returns {Object} Processed home data
     */
    constructHomeData(homeFleetList) {
      const homeData = {
        selfDrive: [],
        Chauffeur: [],
      };
  
      this.helperService.iterations(homeFleetList.selfDrive, function(field) {
        if (field.vehicle.electricVehicle) {
          homeData.selfDrive.push({
            type: "electric",
            name: field.vehicle.label,
            img: field.vehicle.image,
            isElectric: field.vehicle.electricVehicle || false
          });
        } else {
          homeData.selfDrive.push({
            type: field.vehicle.category,
            name: field.vehicle.label,
            img: field.vehicle.image,
            isElectric: field.vehicle.electricVehicle || false
          });
        }
      });
  
      this.helperService.iterations(homeFleetList.Chauffeur, function(field) {
        if (field.vehicle.electricVehicle) {
          homeData.Chauffeur.push({
            type: "electric",
            name: field.vehicle.label,
            img: field.vehicle.image,
            isElectric: field.vehicle.electricVehicle || false
          });
        } else {
          homeData.Chauffeur.push({
            type: field.vehicle.category,
            name: field.vehicle.label,
            img: field.vehicle.image,
            isElectric: field.vehicle.electricVehicle || false
          });
        }
      });
  
      return homeData;
    }
  
    /**
     * Constructs electric vehicle data from fleet list
     * @param {Object} electricFleetList - Electric fleet list data
     * @returns {Object} Processed electric vehicle data
     */
    constructElectricData(electricFleetList) {
      const homeData = {
        selfDrive: [],
        Chauffeur: [],
      };
  
      this.helperService.iterations(electricFleetList.selfDrive, function(field) {
        if (field.vehicle.electricVehicle) {
          homeData.selfDrive.push({
            type: field.vehicle.category,
            name: field.vehicle.label,
            cat: 'electric',
            img: field.vehicle.image
          });
        }
      });
  
      this.helperService.iterations(electricFleetList.Chauffeur, function(field) {
        if (field.vehicle.electricVehicle) {
          homeData.Chauffeur.push({
            type: field.vehicle.category,
            name: field.vehicle.label,
            cat: 'electric',
            img: field.vehicle.image
          });
        }
      });
  
      return homeData;
    }
  
    /**
     * Constructs fleet data according to fleet category
     * @param {Object} fleetList - Fleet list data
     * @returns {Object} Processed fleet data
     */
    constructFleetData(fleetList) {
      const fleetData = {
        selfDrive: [],
        Chauffeur: [],
        airport: {}
      };
  
      const airportData = [];
  
      this.helperService.iterations(fleetList.selfDrive, function(field) {
        fleetData.selfDrive.push({
          type: field.vehicle.categorySelfDrive,
          name: field.vehicle.label,
          fare: field.rate,
          img: field.vehicle.image,
          currency: field.code,
          isElectric: field.vehicle.electricVehicle || false
        });
      });
  
      this.helperService.iterations(fleetList.Chauffeur, function(field) {
        fleetData.Chauffeur.push({
          type: field.vehicle.categoryChauffeured,
          name: field.vehicle.label,
          fare: field.rate,
          img: field.vehicle.image,
          currency: field.code,
          isElectric: field.vehicle.electricVehicle || false
        });
      });
  
      this.helperService.iterations(fleetList.airport, function(field) {
        airportData.push({
          type: field.vehicle.categoryChauffeured,
          name: field.vehicle.label,
          fare: field.rate,
          img: field.vehicle.image,
          currency: field.code,
          IATA: field.IATA,
          isElectric: field.vehicle.electricVehicle || false
        });
      });
  
      const airportGroups = this.helperService.groupBy(airportData, 'IATA');
      const airportKeys = this.helperService.keysIn(airportGroups);
  
      this.helperService.iterations(airportKeys, (key) => {
        airportGroups[key] = this.findCheepestVehicle(airportGroups[key]);
      });
  
      const airportSorted = this.helperService.chain(airportGroups)
        .map((val, key) => ({
          name: key,
          count: val[0].fare,
          value: val
        }))
        .sortBy('count')
        .keyBy('name')
        .mapValues('value')
        .value();
  
      fleetData.airport = airportSorted;
      fleetData.selfDrive = this.findCheepestVehicle(fleetData.selfDrive);
      fleetData.Chauffeur = this.findCheepestVehicle(fleetData.Chauffeur);
      return fleetData;
    }
  
    /**
     * Finds the cheapest fare car of same make/model
     * @param {Array} vehicleList - List of vehicles to process
     * @returns {Array} Sorted list of cheapest vehicles
     */
    findCheepestVehicle(vehicleList) {
      const groupByVehicle = this.helperService.groupBy(vehicleList, 'name');
      const vehiclesKeys = this.helperService.keysIn(groupByVehicle);
      const vehiclesArray = [];
  
      this.helperService.iterations(vehiclesKeys, (vehicleKey) => {
        vehiclesArray.push(
          groupByVehicle[vehicleKey].reduce((prev, curr) => 
            prev.fare < curr.fare ? prev : curr
          )
        );
      });
  
      return this.helperService.sortBy(vehiclesArray, [
        function(o) { return o.fare; }
      ]);
    }
  }